<div class="modal-overlay" *ngIf="show" (click)="close.emit()">
  <div class="modal-container" (click)="$event.stopPropagation()">
    <button class="close-btn" (click)="close.emit()"><i class="fas fa-times"></i></button>
    
    <div class="modal-content">
      <div class="icon-circle">
        <i class="fas fa-crown"></i>
      </div>
      
      <h2 class="modal-title">Quota Exceeded</h2>
      
      <p class="modal-description">
        {{ message || 'You have reached the limit for this action on your current plan. Please wait for your monthly reset or upgrade your plan to continue.' }}
      </p>

      <div class="modal-actions">
        <button class="btn btn-secondary" (click)="close.emit()">Cancel</button>
        <button class="btn btn-primary premium-btn" (click)="upgrade()">
          Upgrade Plan <i class="fas fa-arrow-right"></i>
        </button>
      </div>
    </div>
  </div>
</div>
